// extracted by mini-css-extract-plugin
export default {"paginationContainer":"styles_paginationContainer__5Fgpc","pageItemContainer":"styles_pageItemContainer__YIOOb","page-item":"styles_page-item__nk8Kk","active":"styles_active__0Z1hj"};